import { useFormik } from 'formik'
import React, { FC } from 'react'
import { mutateMany } from 'swr-mutate-many'
import { rejectTransfer } from '../../../adapters/transfer'
import Button from '../../../components/Button'
import CustomDialog from '../../../components/Dialog/CustomDialog'
import { useToastContext } from '../../../contexts/toastContext'
import { Transfer } from '../../../entities/transfer'

interface RejectTransferDialogProps {
	open: boolean
	onClose: () => void

	data: Transfer | undefined
}
const RejectTransferDialog: FC<RejectTransferDialogProps> = ({ open, onClose, data }) => {
	const { addToast } = useToastContext()
	const { isSubmitting, handleSubmit } = useFormik({
		initialValues: {},
		onSubmit: async () => {
			if (!data) {
				return false
			}

			try {
				const res = await rejectTransfer(data.id)

				addToast({
					message: res.message,
					variant: 'success',
				})

				mutateMany('/v1/transfers*')
				onClose()
			} catch ({ message }) {
				addToast({
					message: message,
					variant: 'error',
				})
			}
		},
	})

	return (
		<CustomDialog open={open} onClose={onClose}>
			<div className="w-full sm:w-1/4 bg-white rounded-md p-6 transform">
				<div className="text-center">
					<h3 className="text-lg text-gray-900">ยกเลิกรายการเบิก #{data?.id}</h3>
				</div>
				<form className="space-y-3 mt-5" autoComplete="off" onSubmit={handleSubmit}>
					<div className="grid grid-cols-2 gap-4">
						<Button type="submit" disabled={isSubmitting}>
							ยืนยัน
						</Button>
						<Button
							type="button"
							color="text-gray-900 border border-gray-200 hover:border-gray-300"
							onClick={onClose}
						>
							ยกเลิก
						</Button>
					</div>
				</form>
			</div>
		</CustomDialog>
	)
}

export default RejectTransferDialog
